(() => {
  'use strict';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(':is(.unik-policy, .unik-retningslinjer) [data-unik-consent-open]');
    if (!button || button.disabled) return;

    const section = button.closest('.unik-policy__section');
    const status = section?.querySelector('[data-unik-consent-status]');
    if (!status) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = button.dataset.loadingMessage;

    try {
      const deadline = Date.now() + 8000;
      while (typeof window.privacyBanner?.showPreferences !== 'function') {
        if (Date.now() >= deadline) throw new Error('Consent preferences unavailable');
        await new Promise((resolve) => window.setTimeout(resolve, 100));
      }
      await window.privacyBanner.showPreferences();
      status.textContent = '';
    } catch {
      status.textContent = button.dataset.errorMessage;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
